import { Skeleton } from "@mui/material";
import { BoxContainer, BoxDetailContainer } from "@src/pages/componentGroupOverview/components/articleSubheader/ArticleSubheaderSkeleton.styles";
import { type FunctionComponent } from "react";

import {
    ArrowDownBox,
    ArrowRightBox,
    Root,
    SeparatorDownContainer,
    SeparatorHorizontal,
    SeparatorRightContainer,
    SeparatorVertical,
} from "./ArticleSubheader.styles";

export const ComponentGroupOverviewPageSkeleton: FunctionComponent = ({ ...restProps }) => {
    return (
        <Root {...restProps}>
            <SeparatorRightContainer>
                <SeparatorVertical />

                <ArrowRightBox />
            </SeparatorRightContainer>

            <SeparatorDownContainer>
                <SeparatorHorizontal />

                <ArrowDownBox />
            </SeparatorDownContainer>

            <BoxContainer>
                <Skeleton height={70} width={80} />

                <BoxDetailContainer>
                    <Skeleton height={20} width={50} />

                    <Skeleton height={20} width={280} />

                    <Skeleton height={20} width={180} />
                </BoxDetailContainer>
            </BoxContainer>
        </Root>
    );
};
